var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCollapsed),expression:"isCollapsed"}],staticClass:"text-expander btn-blank",attrs:{"type":"button","aria-label":_vm.ariaLabel},on:{"click":_vm.onClick}},[_vm._v("\n    ...\n  ")]),_vm._v(" "),(!_vm.isCollapsed)?_c('span',[_vm._t("expanded")],2):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3767b76","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/expand_button.vue
// module id = null
// module chunks = 